import { useState } from "react";
import { Database } from "../services/serviceDB";
import FetchForms from "../utils/FetchForms";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faX } from '@fortawesome/free-solid-svg-icons';
import { getId } from "../utils/GenerateID";

export default function Metaform() {
    const [form, setForm] = useState<any>({});
    const [counter, setCounter] = useState(0);
    const [formContent, setFormContent] = useState<any>({});
    const [submitButton, setSubmitButton] = useState(0)

    const childToParent = (childdata) => {
        setForm(childdata)
        setFormContent(childdata.form_content)
        let len = Object.keys(childdata.form_content).length
        let count = len ? len : 0
        setCounter(count)
    }


    function handleClick(event: any): void {
        setCounter(counter+1)
        let newItem="nouveau champ " + counter
        setFormContent(previous => (
            {...previous, 
            [counter]: {
                "label": newItem,
                "input_type": "text",
                "values": []
                }
            }))
    }


    async function handleSubmit(event: any, to_archive=false): Promise<void> {
            if (event) {event.preventDefault();}

            let formData = form
            formData["form_content"] = formContent
    
            if (event) {formData["form_name"] = event.target.elements["form-name"].value}
    
            if (to_archive) {formData["is_archived"] = true} 
            else {formData["is_archived"] = false}

        if (submitButton == 1) {
            formData["form_content"] = formContent
            formData["_id"] = getId()
            delete formData["_rev"]
        }
        let FormDB = new Database("forms", false)

        await FormDB.remote_database.put(formData).then(async function() {
                window.location.reload()
        })
    }


    function handleChange(event: any): void {
        let key = event.target.name 
        let value = event.target.value
        let field = event.target.getAttribute('a-field')
        
        if (key === "values") {
            setFormContent(previous => (
                {...previous, 
                    [field]: {...previous[field], [key]: (value != "") ? value.split(";").map(val => val.trimStart()) : []} 
                }))
        } else {
            setFormContent(previous => (
                {...previous, 
                    [field]: {...previous[field], [key]: value}
                }))
        }
    }


    function handleDelete(id) {
        setFormContent(({[id]: toDelete, ...previous}) => previous);
    }

    
    const handleSelect = (input_type, field, values) => {
        if (input_type === "select") {
            return (
                <div className="form-select-display">
                    <div>
                        <textarea placeholder="Séparer les valeurs par un ;" a-field={field} name='values'></textarea>
                    </div>
                    <div>
                        Choix:
                        <div className="list">
                        {values.map(value => <div key={value}>{value}</div>)}
                        </div>
                    </div>
                </div>
            )
        }
        return (<></>)
    }

    const generateMetaform = () => {
        const metaform = Object.keys(formContent).map(field => {
            return (
                <div className="form-element" id={field} key={field} onChange={handleChange}>
                    <div className="dual">
                    <input type="text" name="label" defaultValue={formContent[field].label} a-field={field}></input>
                    <div><FontAwesomeIcon icon={faX} size="2x" onClick={() => handleDelete(field)}/></div>
                    </div>
                    <select name="input_type" defaultValue={formContent[field].input_type} a-field={field}>
                        <option value="checkbox">checkbox</option>
                        <option value="text">text</option>
                        <option value="select">select</option>
                        <option value="number">number</option>
                        <option value="date">date</option>
                    </select>
                    {handleSelect(formContent[field].input_type, field, formContent[field].values)}
                </div>
                
            )
        })
        return (
            <div className="generated-form">
            <label htmlFor='name'>Nom du formulaire:</label>
            <input type='text'id='form-name' required defaultValue={form["form_name"]}/>
            {metaform}
            </div>
        )
      }

    return (
        <>
        {FetchForms({childToParent}, true, true, true)}
        {form.is_archived ? 
        (<button className="desarchive-button" onClick={() => handleSubmit(false, false)}> Désarchiver </button>) 
        : 
        (<button className="archive-button" onClick={() => handleSubmit(false, true)}> Archiver </button>)} 

        <form onSubmit={handleSubmit}>
            {generateMetaform()}
            <input type="submit" onClick={() => setSubmitButton(1)} value="Créer une copie de ce formulaire"/>
            <input type="submit" onClick={() => setSubmitButton(0)} value="Créer ou modifier ce formulaire"/>

        </form>

        <button className="new-element-button" onClick={handleClick}>
        <FontAwesomeIcon className="new-element-button-fa" icon={faPlus} size="3x" border/>
            </button>
        </>
    )
}
